import * as React from "react";
import { OI } from "../onam/mark";
import { FEATURES } from "../onam/features";

type Props = React.SVGProps<SVGSVGElement> & { title?: string };

function BaseCopyIcon({ title, ...props }: Props) {
  return (
    <svg
      width={19}
      height={20}
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={title ? undefined : true}
      role="img"
      {...props}
    >
      {title ? <title>{title}</title> : null}
      <path
        d="M15.8264 5.28516H7.78244C7.52873 5.28581 7.27765 5.33648 7.04354 5.43427C6.80944 5.53205 6.59691 5.67503 6.41812 5.85503C6.23933 6.03503 6.09778 6.24852 6.00157 6.48327C5.90536 6.71803 5.85639 6.96945 5.85744 7.22316V17.3112C5.85744 18.3812 6.71944 19.2492 7.78244 19.2492H15.8264C16.0801 19.2485 16.3312 19.1978 16.5653 19.1C16.7994 19.0023 17.012 18.8593 17.1908 18.6793C17.3695 18.4993 17.5111 18.2858 17.6073 18.051C17.7035 17.8163 17.7525 17.5649 17.7514 17.3112V7.22316C17.7514 6.15316 16.8894 5.28516 15.8264 5.28516Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.142 5.286V2.688C13.142 2.174 12.939 1.681 12.578 1.318C12.3998 1.13829 12.1878 0.995594 11.9543 0.898115C11.7207 0.800636 11.4701 0.750299 11.217 0.75H3.17305C2.66305 0.75 2.17305 0.954 1.81305 1.318C1.45177 1.68252 1.24876 2.17478 1.24805 2.688V12.776C1.24805 13.29 1.45105 13.783 1.81205 14.146C2.17305 14.509 2.66205 14.714 3.17305 14.714H5.85805"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/* With the ONAM skin (FEATURES.curationSkin) this draws ONAM's "copy" glyph instead (onam/mark.tsx). */
const CopyIconSkin = (props: any) =>
  FEATURES.curationSkin ? (
    <OI n="copy" size={props.size || 16} className={props.className} style={props.style} onClick={props.onClick} title={props.title} color={props.color}
      onMouseOver={props.onMouseOver} onMouseOut={props.onMouseOut} onMouseEnter={props.onMouseEnter} onMouseLeave={props.onMouseLeave} />
  ) : (
    <BaseCopyIcon {...props} />
  );
export default CopyIconSkin;
